import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MinimizableWebChat from '../../application/commons/chat/MinimizableWebChat';



// Define the routes for the user module
const ChatRoutes: React.FC = () => {
    return (
        <Routes>
            <Route >
                <Route index element={<ChatHome />} />  {/* Renders at /user */}
            </Route>
        </Routes>
    );
};

// Home component for /user
const ChatHome: React.FC = () => {

    return (
        <div >
            <div className="m-2">

                <MinimizableWebChat bot="B0002" />
            </div>

        </div>
    );
};



export default ChatRoutes;
